export { BiSearchAlt as SearchIcon } from 'react-icons/bi';
export { BiArrowBack as ArrowBackIcon } from 'react-icons/bi';
export { MdPersonSearch as PersonSearchIcon } from 'react-icons/md';
export { FaGraduationCap as StudentIcon } from 'react-icons/fa';
export { FaChalkboardTeacher as ResearcherIcon } from 'react-icons/fa';
export { FaIndustry as CompanyIcon } from 'react-icons/fa';
export { FaPeopleCarry as ContributorIcon } from 'react-icons/fa';
export { FaIdCardAlt as PersonIcon } from 'react-icons/fa';
export { GiPoliceOfficerHead as SupervisorIcon } from 'react-icons/gi';
